import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

function mapMemberCommitteeFromApi(d) {
  return {
    id: d.id,
    companyId: d.companyId,
    companyName: d.companyName ?? '',
    name: d.name ?? '',
    type: d.type ?? 'permanent',
    description: d.description ?? '',
    createdAt: d.createdAt ? String(d.createdAt).slice(0, 10) : '',
    isActive: !!d.isActive,
    membersCount: Number(d.membersCount ?? 0),
    chairmanName: d.chairmanName ?? '',
    members: Array.isArray(d.members)
      ? d.members.map((m) => ({
        id: m.id,
        boardMemberId: m.boardMemberId,
        boardMemberName: m.boardMemberName ?? '',
        role: m.role ?? 'member',
      }))
      : [],
  };
}

export async function fetchMemberCommittees() {
  const res = await fetch(`${API_BASE}/api/member/committees`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل اللجان'));
  const list = Array.isArray(data) ? data : [];
  return list.map(mapMemberCommitteeFromApi);
}
